export const tag_list_en =["1940s"	,
"1950s"	,
"1960s"	,
"1970s"	,
"1980s"	,
"1990s"	,
"3D"	,
"Abstract flower"	,
"African"	,
"Apple"	,
"Aqua"	,
"Architectural"	,
"Art"	,
"Art Nouveau"	,
"Artistic"	,
"Arts & crafts"	,
"Autumn"	,
"Autumn/Winter"	,
"Aztec"	,
"Bamboo"	,
"Banana"	,
"Bandana"	,
"Baroque"	,
"Batik"	,
"Bauhaus"	,
"Beetle"	,
"Big flowers"	,
"Birds"	,
"Black"	,
"Black and white"	,
"Bloom"	,
"Blossom"	,
"Blue"	,
"Blue and white"	,
"Blurred"	,
"Boats"	,
"Bold"	,
"Botanical"	,
"Bouquet"	,
"Bright"	,
"Brown"	,
"Brushstrokes"	,
"Butterflies"	,
"Cactus"	,
"Candy"	,
"Cars"	,
"Cartoon"	,
"Cat"	,
"Chains"	,
"Cherries"	,
"Chevron"	,
"Chinoiserie"	,
"Christmas"	,
"Circles"	,
"Clouds"	,
"Collage"	,
"Colourful"	,
"Contemporary"	,
"Coral"	,
"Cream"	,
"Cute"	,
"Cyan"	,
"Daffodil"	,
"Daisy"	,
"Damask"	,
"Dark"	,
"Dark blue"	,
"Dark green"	,
"Decorative"	,
"Detailed"	,
"Diamonds"	,
"Digital"	,
"Distorted"	,
"Ditsy"	,
"Dog"	,
"Dolphin"	,
"Doodle"	,
"Dots"	,
"Drinks"	,
"Elephant"	,
"Embroidery"	,
"Exotic"	,
"Faded"	,
"Fall"	,
"Fall/winter"	,
"Feathers"	,
"Fern"	,
"Fish"	,
"Flamingos"	,
"Flourish"	,
"Foliage"	,
"Folk"	,
"Folkloric"	,
"Food"	,
"Forest"	,
"Foulard"	,
"Frogs"	,
"Fruit"	,
"Fuchsia"	,
"Fun"	,
"Futuristic"	,
"Galaxy"	,
"Gingham"	,
"Giraffe"	,
"Girls"	,
"Gold"	,
"Gothic"	,
"Graffiti"	,
"Graphic"	,
"Graphic floral"	,
"Graphic pattern"	,
"Green"	,
"Grey"	,
"Grunge"	,
"Halloween"	,
"Hand painted"	,
"Hawaiian"	,
"Hearts"	,
"Herringbone"	,
"Hibiscus"	,
"High summer"	,
"Holiday"	,
"Horses"	,
"Houndstooth"	,
"Ice-cream"	,
"Ikat"	,
"Illustration"	,
"Impressionist"	,
"Indian"	,
"Indigo"	,
"Ink"	,
"Insects"	,
"Iridescent"	,
"Iris"	,
"Jacquard"	,
"Japanese"	,
"Jewel"	,
"Jungle"	,
"Kaleidoscope"	,
"Kimono"	,
"Knit"	,
"Lace"	,
"Landscape"	,
"Large scale"	,
"Lavender"	,
"Layered"	,
"Leaves"	,
"Lemon"	,
"Leopard"	,
"Letters"	,
"Light"	,
"Lilac"	,
"Lily"	,
"Linear"	,
"Lines"	,
"Magenta"	,
"Magnolia"	,
"Mandala"	,
"Marble"	,
"Meadow"	,
"Mexican"	,
"Minimal"	,
"Mirrored"	,
"Mixed media"	,
"Modern"	,
"Modernism"	,
"Monochrome"	,
"Moroccan"	,
"Mosaic"	,
"Moth"	,
"Motif"	,
"Multicolor"	,
"Naïve"	,
"Nautical"	,
"Navy"	,
"Neon"	,
"Nordic"	,
"Numbers"	,
"Ocean"	,
"Ombre"	,
"Optical"	,
"Orange"	,
"Orchid"	,
"Oriental"	,
"Ornamental"	,
"Painted"	,
"Paisley"	,
"Palm"	,
"Pansy"	,
"Parrot"	,
"Pastel"	,
"Patchwork"	,
"Peony"	,
"People"	,
"Petals"	,
"Photographic"	,
"Pineapple"	,
"Pink"	,
"Pixel"	,
"Plants"	,
"Playful"	,
"Poppy"	,
"Pretty"	,
"Psychedelic"	,
"Punk"	,
"Purple"	,
"Rabbit"	,
"Red"	,
"Resort"	,
"Retro"	,
"Romantic"	,
"Roses"	,
"Scarf"	,
"Scribble"	,
"Shapes"	,
"Shibori"	,
"Silhouette"	,
"Silver"	,
"Simple"	,
"Sketched"	,
"Skull"	,
"Small Scale"	,
"Snake"	,
"Space"	,
"Spaced"	,
"Spots"	,
"Spring"	,
"Spring/summer"	,
"Squares"	,
"Starfish"	,
"Stars"	,
"Stencil"	,
"Strawberry"	,
"Street art"	,
"Summer"	,
"Summer Festival"	,
"Sweets"	,
"Swirls"	,
"Symmetrical"	,
"Tartan"	,
"Teal"	,
"Tie dye"	,
"Tiger"	,
"Tonal"	,
"Trees"	,
"Triangles"	,
"Tulip"	,
"Turquoise"	,
"Valentine"	,
"Vector pattern"	,
"Vegetables"	,
"Vibrant"	,
"Vintage"	,
"Violet"	,
"Wallpaper"	,
"Watercolour"	,
"Waves"	,
"Weave"	,
"Whale"	,
"White"	,
"Wild flowers"	,
"Winter"	,
"Wrapping paper"	,
"Yellow"	,
"Zebra"	,
"Zig zag"]